import { formatBytes } from '@lib/utils/units'
import type { CancelToken } from 'axios'

import type { StorageLimits } from '@/types/models'
import type { StorageLimitsResponse } from '@/types/responses'
import request from './request'

export const getCancelableUserStorageLimits = async (
  cancelToken: CancelToken
): Promise<StorageLimits> => {
  const { max, usage } = await request.get<StorageLimitsResponse>(
    `/my/storage-usage`,
    {},
    { cancelToken }
  )

  const hMax = formatBytes(max)
  const hUsage = formatBytes(usage)
  const percentageUsage = Math.round((100 * usage) / max)

  return {
    hMax,
    hUsage,
    max,
    usage,
    percentageUsage,
  }
}
